import 'react-app-polyfill/ie11';
import 'core-js/es6/array';
import 'core-js/es7/array';


import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { ThemeProvider } from 'styled-components';

import appStorage from './utils/appStorage';

import 'react-toastify/dist/ReactToastify.css';
import theme from './styles/theme';

import App from './App';

appStorage.init(
  {},
  {
    partGroupsLoaded: []
  }
);

const token = window._env_.REACT_APP_GRAPHQL_TOKEN;

const graphqlClient = new ApolloClient({
  link: createHttpLink({
    uri: window._env_.REACT_APP_GRAPHQL_ENDPOINT,
    headers: {
      authorization: token ? `Bearer ${token}` : ''
    }
  }),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__)
});

window.onload = () => {
  ReactDOM.hydrate(
    <ApolloProvider client={graphqlClient}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </ApolloProvider>,

    document.getElementById('root')
  );

  document.getElementById('root').classList.remove('fadein');
};
